// Copyright ©️ 2026 eVolve MEP, LLC

import { ToggleRadioGroup } from 'components/Mantine/TypeSafeSelect/ToggleRadioGroup';
import { isNil } from 'helpers/isNotNil';
import { useConduits } from 'modules/Shop/EvolveFabrication/useConduits';

import { useBendCreatorValidationContext } from '../Context/useBendCreatorValidationContext';

export const BendConduitSelection = () => {
  const { conduitTypes, conduitSizes, loading: loadingConduits } = useConduits();

  const { fieldGetInputProps } = useBendCreatorValidationContext();

  return (
    <>
      <ToggleRadioGroup
        label="Material"
        loading={isNil(conduitTypes) || loadingConduits}
        required
        {...fieldGetInputProps.conduitTypeId()}
        data={
          conduitTypes?.map(({ conduitTypeId, name }) => ({
            id: conduitTypeId,
            value: conduitTypeId,
            label: name,
          })) ?? []
        }
      />
      <ToggleRadioGroup
        label="Conduit Size"
        data={
          conduitSizes?.map(({ conduitSizeId, name }) => ({
            id: conduitSizeId,
            label: name,
            value: conduitSizeId,
          })) ?? []
        }
        cols={5}
        loading={isNil(conduitSizes) || loadingConduits}
        required
        {...fieldGetInputProps.conduitSizeId()}
      />
    </>
  );
};
